import React, { useState } from 'react';
import { Spin } from 'antd';

import AgGrid from "../../../../../../components/ag-grid-table/index";
import PlacementCard from '../../../../../../components/uiComponent/placement-card';
import Button from "../../../../../../components/uiComponent/button/index";

import { ShippingWrapper } from '../style';
import { STORAGE_IMAGE_URL } from '../../../../../../constants/storage.js';

const ProductImg = `${STORAGE_IMAGE_URL}/newImages/nestle.svg`;

const Step1 = () => {
  const [activeCard, setActiveCard] = useState(1);
  const [rowData] = useState(
    Array.from({ length: 10 }, (_, index) => ({
      id: index,
      items: "Product Title Name will here",
      sku: "FJ-NQJ0-C76",
      asin: "FJ-NQJ0-C76",
      quantity: 100,
    }))
  );
  const [selectedOptions, setSelectedOptions] = useState({
    placementIndex: null,
    shipmentIndex: null,
  });

  const [inboundPlans, setInboundPlans] = useState([
    {
      shipmentDetails: [{ shipmentId: "SHIP1" }],
      items: [{ id: 1, shipmentId: "SHIP1" }],
    },
    {
      shipmentDetails: [{ shipmentId: "SHIP2" }],
      items: [{ id: 2, shipmentId: "SHIP2" }],
    },
  ]);

  const handleCardClick = (id) => {
    setActiveCard(id === activeCard ? null : id);
  };

  const columnDefs = [
    {
      headerName: "Items",
      field: "items",
      flex: 1,
      cellRenderer: (props) => (
        <div className='product-item-wrapper'>
          <img
            src={ProductImg}
            alt="Product"
          />
          <span className='product-item'>{props.value}</span>
        </div>
      ),
    },
    { headerName: "SKU", field: "sku", flex: 1 },
    { headerName: "ASIN", field: "asin", flex: 1 },
    { headerName: "Quantity", field: "quantity", flex: 1 },
  ];

  const tabsLabel = [
    {
      id: 1,
      shipmentId: 'PKG-OPT-001',
      fcAddress: 'US Line 1, address C block'
    },
    {
      id: 2,
      shipmentId: 'PKG-OPT-001',
      fcAddress: 'US Line 1, address C block'
    },
    {
      id: 3,
      shipmentId: 'PKG-OPT-001',
      fcAddress: 'US Line 1, address C block'
    },
    {
      id: 4,
      shipmentId: 'PKG-OPT-001',
      fcAddress: 'US Line 1, address C block'
    },
    {
      id: 5,
      shipmentId: 'PKG-OPT-001',
      fcAddress: 'US Line 1, address C block'
    },
    {
      id: 6,
      shipmentId: 'PKG-OPT-001',
      fcAddress: 'US Line 1, address C block'
    },
    {
      id: 7,
      shipmentId: 'PKG-OPT-001',
      fcAddress: 'US Line 1, address C block'
    },
    {
      id: 8,
      shipmentId: 'PKG-OPT-001',
      fcAddress: 'US Line 1, address C block'
    },
  ]

  const defaultColDef = {
    resizable: true,
    sortable: false,
    filter: false,
    suppressRowClickSelection: true,
    suppressMenu: true,
    suppressMovable: true,
  };

  return (
    <ShippingWrapper className='step1'>
        <div className='tabs-cards-wrapper'>
          {tabsLabel.map((item) => (
            <div key={item.id}
              className={`tab-item-wrapper ${activeCard === item.id ? 'active' : ''}`}
              onClick={() => handleCardClick(item.id)}>
              <div className='tab-item'>
                <p>Shipment ID</p>
                <p>{item.shipmentId}</p>
              </div>
              <div className='tab-item'>
                <p>FC Address</p>
                <p>{item.fcAddress}</p>
              </div>
            </div>
          ))}
        </div>
        <Spin tip='Loading...' spinning={false}>
          <AgGrid
            user_referrals={rowData}
            defaultColDef={defaultColDef}
            columnDefinitions={columnDefs}
            rowHeight={64}
            headerHeight={36}
            height="486px"
            masterDetail={true}
            detailRowAutoHeight={true}
            className="sku-table"
          />
        </Spin>
    </ShippingWrapper>
  )
}

export default Step1;
